<template>
  <div class="app-shell">
    <main :class="isUnprotectedRoute ? 'content-root-out' : 'content-root'">
      <MenuComponent v-if="!isUnprotectedRoute" />

      <div class="content-and-footer">
        <transition name="fade">
          <router-view />
        </transition>

        <template v-if="!isUnprotectedRoute">
          <span class="footer-line"></span>
          <FooterComponent />
        </template>
      </div>
    </main>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import MenuComponent from './components/Menu.vue'
import FooterComponent from './components/Footer.vue'

@Component({
  components: {
    MenuComponent,
    FooterComponent
  }
})
export default class App extends Vue {
  get isUnprotectedRoute(): boolean {
    const isUnprotectedRoute = (name: string | null | undefined) => {
      if (name) return ['login', 'logout'].includes(name)
      return false
    }

    const currentRouteName = this.$route.name
    return isUnprotectedRoute(currentRouteName)
  }
}
</script>

<style lang="scss">
@import './styles/main.scss';

.app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-root {
  background-color: rgba(255, 255, 255, 1);
  display: grid;
  grid-template-columns: 191px 1fr;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  margin: auto;
  flex: 1;
}

.content-root-out {
  background-color: rgba(255, 255, 255, 1);
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  margin: auto;
  flex: 1;
}

.content-and-footer {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.footer-line {
  display: block;
  width: 100%;
  max-width: 1032px;
  height: 1px;
  background-color: rgba(179, 179, 179, 1);
  margin: 0 auto;
}

/* fade (screen transition) */
.fade-leave-active {
  transition: opacity 0.5s linear;
}

.fade-enter-active {
  transition: opacity 0.5s linear 0.5s;
}

.fade-enter,
.fade-leave-to,
.fade-leave-active

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
